(function($) {

  function nthSlickSlider() {
    $('.nth-accordion-slider').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                speed: 500,
                fade: true,
                cssEase: 'linear'
            });
        }
    });

    var $slider = $('.nth-product-tooltip-products-slider');
    var $tooltips = $('.nth-product-tooltip-item');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(this).find('.slick-prev, .slick-next').css('opacity', '0');
        }).on('afterChange', function (event, slick, currentSlide) {
            $(this).find('.slick-prev, .slick-next').css('opacity', '1');

            $tooltips.removeClass('active');
            $('.nth-product-tooltip-item[data-tooltip-index="' + (currentSlide + 1) + '"]').addClass('active');
        });

        $tooltips.on('click', function () {
            var index = $(this).data('tooltip-index') - 1;
            $slider.slick('slickGoTo', index);
        });
    }

    $('.nth-collection-products-lists .product-list').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
                slidesToShow: 4, 
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: true,
                responsive: [
                  {
                    breakpoint: 999,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      dots: true,
                      arrows: false
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: true,
                      arrows: false
                    }
                  }
                ]
            });
        }
    });
    
  }

  // Product Gallery Hover Zoom for Desktop
  function nthProductImageZoom() {
    // Only apply on desktop (min-width: 1024px)
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    if (!isDesktop) return;

    const galleryMedia = document.querySelectorAll('.nth-product-gallery-wrapper .product-gallery__media');
    
    if (galleryMedia.length === 0) {
      return;
    }

    galleryMedia.forEach(function(mediaItem, index) {
      const img = mediaItem.querySelector('img');
      if (!img) return;

      // Skip if already initialized
      if (mediaItem.hasAttribute('data-zoom-initialized')) {
        return;
      }
      mediaItem.setAttribute('data-zoom-initialized', 'true');

      const zoomCircle = document.createElement('div');
      zoomCircle.className = 'nth-zoom-circle';
      zoomCircle.style.cssText = `
        position: absolute;
        width: 350px;
        height: 350px;
        border-radius: 50%;
        overflow: hidden;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s;
        z-index: 100;
        background: white;
        border: 6px solid #ffffff;
        box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      `;
      
      const zoomImg = document.createElement('img');
      // Get the original full-size image URL
      let fullSizeUrl = img.src;
      // Remove size parameters to get full size
      fullSizeUrl = fullSizeUrl.replace(/_(small|medium|large|compact|grande|pico|icon|thumb|1024x1024|2048x2048|100x|160x|200x|360x|480x|600x|720x|960x|1200x|1400x|1600x|1800x)\./, '.');
      fullSizeUrl = fullSizeUrl.replace(/\?v=\d+&width=\d+/, '');
      
      zoomImg.src = fullSizeUrl;
      zoomImg.style.cssText = `
        position: absolute;
        max-width: none;
        width: auto;
        height: auto;
      `;
      
      zoomCircle.appendChild(zoomImg);
      mediaItem.style.position = 'relative';
      mediaItem.appendChild(zoomCircle);

      mediaItem.addEventListener('mouseenter', function() {
        zoomCircle.style.opacity = '1';
        mediaItem.style.cursor = 'none';
      });

      mediaItem.addEventListener('mouseleave', function() {
        zoomCircle.style.opacity = '0';
        mediaItem.style.cursor = 'default';
      });

      mediaItem.addEventListener('mousemove', function(e) {
        const rect = mediaItem.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Position the circle centered on cursor
        const circleSize = 350;
        const circleX = x - (circleSize / 2);
        const circleY = y - (circleSize / 2);
        
        zoomCircle.style.left = circleX + 'px';
        zoomCircle.style.top = circleY + 'px';
        
        // Calculate zoom image dimensions (3x zoom)
        const zoomLevel = 3;
        const imgWidth = rect.width * zoomLevel;
        const imgHeight = rect.height * zoomLevel;
        
        // Set zoom image size
        zoomImg.style.width = imgWidth + 'px';
        zoomImg.style.height = imgHeight + 'px';
        
        // Calculate position to show the zoomed area centered on cursor
        const xPercent = x / rect.width;
        const yPercent = y / rect.height;
        
        const moveX = xPercent * imgWidth - (circleSize / 2);
        const moveY = yPercent * imgHeight - (circleSize / 2);
        
        zoomImg.style.left = -moveX + 'px';
        zoomImg.style.top = -moveY + 'px';
      });
    });
  }

  // Select Car Toggle
  function nthSelectCarToggle() {
    // Toggle open/close (remove previous bindings first to avoid duplicates)
    $('.top-form-search-box')
      .off('click.nthSelectCar')
      .on('click.nthSelectCar', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $wrap = $(this).closest('.nth-select-car-wrapper');
        if (!$wrap.length) {
          return;
        }
        var $selectCar = $wrap.find('select-car');

        $selectCar.stop(true, true).fadeToggle(300);
      });

    // Prevent clicks inside the dropdown from bubbling up and closing it
    $('select-car')
      .off('click.nthSelectCar')
      .on('click.nthSelectCar', function (e) {
        e.stopPropagation();
      });

    // Optional: click outside closes any open dropdowns (also de-duped)
    $(document)
      .off('click.nthSelectCar')
      .on('click.nthSelectCar', function () {
        $('.nth-select-car-wrapper select-car:visible').stop(true, true).fadeOut(300);
      });

    // Reset button
    $('.top-form-search-reset')
      .off('click.nthSelectCar')
      .on('click.nthSelectCar', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Clear the cookie
        deleteCookie('selected_car');

        // Remove filter parameter from URL and reload
        const url = new URL(window.location.href);
        url.searchParams.delete('filter.p.m.custom.make_model_year');
        window.location.href = url.toString();
      });
  }

  // Cookie helper functions
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return null;
  }

  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  // Update Select Car display based on cookie or URL parameter
  function updateSelectCarDisplay() {
    // Check URL parameter first, then fall back to cookie
    const urlParams = new URLSearchParams(window.location.search);
    let selectedCarParam = urlParams.get('filter.p.m.custom.make_model_year');
    
    // If no URL param, check cookie
    if (!selectedCarParam) {
      selectedCarParam = getCookie('selected_car');
    }
    
    if (selectedCarParam) {
      // Decode and format the car name (replace underscores with spaces)
      const carName = decodeURIComponent(selectedCarParam).replace(/_/g, ' ');

      // Ensure sidebar select-car block shows selected state even when Liquid can't resolve active filter values.
      $('.nth-select-car-item-wrapper').each(function() {
        const $item = $(this);
        const $content = $item.find('.nth-select-car-content').first();
        const $sidebarForm = $content.find('.nth-select-car-wrapper-sidebar').first();
        let $selectedTop = $content.find('.select-car-top-form').first();

        $item.addClass('is-selected');

        if (!$selectedTop.length) {
          $content.prepend(
            '<div class="select-car-top-form">' +
              '<div class="top-form-search-box">' +
                '<div class="top-form-search-box-placeholder" data-default-text="Choose Model"></div>' +
              '</div>' +
              '<div class="top-form-search-reset">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_5743_90)"><path d="M1.5 10C1.5 5.30559 5.30559 1.5 10 1.5C14.6945 1.5 18.5 5.30559 18.5 10C18.5 14.6945 14.6945 18.5 10 18.5C5.30559 18.5 1.5 14.6945 1.5 10Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.36182 7.36206L12.6377 12.6379" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.6377 7.36206L7.36182 12.6379" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_5743_90"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>' +
              '</div>' +
            '</div>'
          );

          $selectedTop = $content.find('.select-car-top-form').first();
        }

        if ($sidebarForm.length) {
          $sidebarForm.hide();
        }

        $selectedTop.find('.top-form-search-box-placeholder').text(carName);
      });
      
      // Update the label
      $('.top-form-label').text('Ute Selected');
      
      // Update the placeholder
      $('.top-form-search-box-placeholder').text(carName);
    } else {
      // Reset to default values
      const defaultLabel = $('.top-form-label').data('default-text') || 'Select ute:';
      const defaultPlaceholder = $('.top-form-search-box-placeholder').data('default-text') || 'Choose Model';
      
      $('.top-form-label').text(defaultLabel);
      $('.top-form-search-box-placeholder').text(defaultPlaceholder);
    }
  }

  // Apply filter from cookie or save filter parameter to cookie
  function applyCarFilterFromCookie() {
    const urlParams = new URLSearchParams(window.location.search);
    const filterParam = urlParams.get('filter.p.m.custom.make_model_year');
    const selectCarParam = urlParams.get('select_car');
    
    // If filter parameter exists in URL, save it to cookie (overwrites existing)
    if (filterParam) {
      const currentCookie = getCookie('selected_car');
      // Only update cookie if it's different from what's already saved
      if (currentCookie !== filterParam) {
        setCookie('selected_car', filterParam, 30);
      }
      return; // Filter already in URL, no redirect needed
    }
    
    // If select_car parameter exists, save it to cookie and redirect with filter
    if (selectCarParam) {
      // Save to cookie (30 days) - this overwrites any existing cookie
      setCookie('selected_car', selectCarParam, 30);
      
      // Remove select_car param and add filter param
      urlParams.delete('select_car');
      urlParams.set('filter.p.m.custom.make_model_year', selectCarParam);
      const newUrl = window.location.pathname + '?' + urlParams.toString();
      window.location.href = newUrl;
      return;
    }
    
    // No filter in URL, try to apply from cookie
    const savedCar = getCookie('selected_car');
    if (savedCar) {
      // Check if we're on a collection or product page that should have filtering
      const isCollectionPage = window.location.pathname.includes('/collections/');
      const isProductPage = window.location.pathname.includes('/products/');
      
      if (isCollectionPage || isProductPage) {
        // Add filter parameter and reload
        urlParams.set('filter.p.m.custom.make_model_year', savedCar);
        const newUrl = window.location.pathname + '?' + urlParams.toString();
        window.location.href = newUrl;
      }
    }
  }

  function nthSelectCarToggleMobile() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    
    $('.nth-select-car-item-wrapper[data-nth-select-car-collapsible]').each(function() {
      var $wrapper = $(this);
      var $title = $wrapper.find('.nth-select-car-title');
      var $content = $wrapper.find('.nth-select-car-content');

      if (!$title.length) {
        return;
      }

      if (!isMobile) {
        $wrapper.removeClass('is-collapsed');
        $title.attr('aria-expanded', 'true');
      } else {
        var isSelected = $wrapper.hasClass('is-selected');
        if (isSelected) {
          $wrapper.removeClass('is-collapsed');
          $title.attr('aria-expanded', 'true');
        } else {
          $wrapper.addClass('is-collapsed');
          $title.attr('aria-expanded', 'false');
        }
      }

      $title
        .off('click.nthSelectCarMobile keydown.nthSelectCarMobile')
        .on('click.nthSelectCarMobile', function(e) {
          if (!isMobile) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          var isCollapsed = $wrapper.hasClass('is-collapsed');
          $wrapper.toggleClass('is-collapsed', !isCollapsed);
          $title.attr('aria-expanded', String(!isCollapsed));
        })
        .on('keydown.nthSelectCarMobile', function(e) {
          if (!isMobile || (e.key !== 'Enter' && e.key !== ' ')) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();
          $(this).trigger('click');
        });
    });
  }

  function nthSidebarFilterToggle() {
    $('.nth-collection-side-toolbar-filter-title')
      .off('click.nthSidebarFilter keydown.nthSidebarFilter')
      .on('click.nthSidebarFilter', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $title = $(this);
        var $item = $title.closest('.nth-collection-side-toolbar-filter-item');
        var $content = $item.find('.nth-collection-side-toolbar-filter-content').first();
        var isCollapsed = $item.hasClass('is-collapsed');

        if (isCollapsed) {
          $item.removeClass('is-collapsed');
          $title.attr('aria-expanded', 'true');
          $content.stop(true, true).slideDown(200);
        } else {
          $item.addClass('is-collapsed');
          $title.attr('aria-expanded', 'false');
          $content.stop(true, true).slideUp(200);
        }
      })
      .on('keydown.nthSidebarFilter', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          $(this).trigger('click');
        }
      });
  }

  function nthCollectionDescriptionToggle() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    $('.nth-collection-description[data-nth-collapsible-description]').each(function() {
      var $description = $(this);
      var $toggle = $description.find('.nth-collection-description__toggle');
      var $content = $description.find('.nth-collection-description__content');

      if (!$toggle.length) {
        return;
      }

      var toggleDescription = function() {
        var isExpanded = $description.hasClass('is-expanded');
        $description.toggleClass('is-expanded', !isExpanded);
        $toggle.attr('aria-expanded', String(!isExpanded));
        $toggle.attr('aria-label', !isExpanded ? 'Collapse collection description' : 'Expand collection description');
      };

      if (!isMobile) {
        $description.addClass('is-expanded');
        $toggle.attr('aria-expanded', 'true');
        $toggle.attr('aria-label', 'Collapse collection description');
      } else {
        $description.removeClass('is-expanded');
        $toggle.attr('aria-expanded', 'false');
        $toggle.attr('aria-label', 'Expand collection description');
      }

      $toggle
        .off('click.nthCollectionDescription')
        .on('click.nthCollectionDescription', function(e) {
          e.preventDefault();
          toggleDescription();
        });

      $content
        .off('click.nthCollectionDescription')
        .on('click.nthCollectionDescription', function(e) {
          if (!isMobile) {
            return;
          }

          if ($(e.target).closest('a, button').length) {
            return;
          }

          e.preventDefault();
          toggleDescription();
        });
    });
  }

  $(window).on('load', function() {
    nthSlickSlider();
    applyCarFilterFromCookie();
    updateSelectCarDisplay();
    nthSelectCarToggle();
    nthSelectCarToggleMobile();
    nthSidebarFilterToggle();
    nthCollectionDescriptionToggle();
    
    console.log('Window loaded - initializing zoom');
    // Initialize zoom with delay to ensure gallery is loaded
    setTimeout(nthProductImageZoom, 500);
    
    // Also try immediately
    nthProductImageZoom();
  });

  document.addEventListener('shopify:section:load', function() {
    nthSelectCarToggle();
    nthSelectCarToggleMobile();
    nthSidebarFilterToggle();
    nthCollectionDescriptionToggle();
  });

  // Re-initialize zoom on variant change
  $(document).on('variant:changed', function() {
    setTimeout(nthProductImageZoom, 100);
  });

  // Watch for new gallery media being added
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          nthProductImageZoom();
        }
      });
    });

    $(window).on('load', function() {
      const galleryWrapper = document.querySelector('.nth-product-gallery-wrapper');
      if (galleryWrapper) {
        observer.observe(galleryWrapper, { childList: true, subtree: true });
      }
    });
  }

  // Keep NTH collection sort select in sync with the theme's AJAX facet system.
  document.addEventListener('change', function(event) {
    const sortSelect = event.target.closest('[data-nth-sort-select]');

    if (!sortSelect) {
      return;
    }

    const sectionId = sortSelect.getAttribute('data-section-id');

    if (!sectionId) {
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', sectionId);

    sortSelect.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url }
    }));
  });

})(jQuery);